import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import LogoContainer from 'containers/LogoContainer';
import './ConfirmCart.scss';

const ConfirmCart = ({
  isOpen, onClose, onConfirm,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.classList.add('confirm-cart-open');
    return () => document.body.classList.remove('confirm-cart-open');
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="confirm-cart-overlay">
      <div className="confirm-cart">
        <div className="confirm-cart__content">
          <LogoContainer />
          <br />
          <strong>
            Estás a punto de finalizar tu pedido.
            {' '}
            Se te redirigirá automáticamente a WhatsApp para coordinar el pago
            {' '}
            y el envío con uno de nuestros vendedores.
          </strong>
          <br />
          <br />
          <strong>¿FINALIZAR PEDIDO?</strong>
        </div>
        <div className="confirm-cart__actions">
          <button className="btn btn-confirm" onClick={onConfirm} type="button">
            Finalizar Pedido
          </button>
          <button className="btn btn-close" onClick={onClose} type="button">
            Volver al carrito
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

ConfirmCart.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmCart;
